import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { useState } from 'react';
import { WizardButtons } from '../../Wizard/WizardButtons';
import { useQuery } from '@tanstack/react-query';
import { GetPoliciesForInsuredBySinglePolicy } from '../../../../../api/phone';
import { TitledCircularProgress } from '../../feedback/TitledCircularProgress/TitledCircularProgress';

export const PolicyCheck = (props) => {
  let items = [];
  if (JSON.parse(localStorage.getItem('policyCheckItems')) !== null) {
    items = JSON.parse(localStorage.getItem('policyCheckItems'));
  }
  const [policyCheckItems, setPolicyCheckItems] = useState(items);

  const getPolicyQuery = useQuery({
    queryKey: ['getPoliciesForInsuredBySinglePolicy', props.referenceID],
    queryFn: async () =>
      await GetPoliciesForInsuredBySinglePolicy({ PolicyID: props.referenceID })(),
    gcTime: 1, // Renamed from cacheTime in v5
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  const handlePolicyCheckBox = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setPolicyCheckItems([...policyCheckItems, value]);
    } else {
      setPolicyCheckItems((prev) => prev.filter((item) => item !== value));
    }
  };

  const handlePolicyCheckSubmit = () => {
    if (props.clickOnDocu) {
      localStorage.setItem('policyCheckItems', JSON.stringify(policyCheckItems));
      props.nextHandler();
    } else {
      props.skipHandler(3);
    }
  };

  if (getPolicyQuery.isPending) {
    return <TitledCircularProgress title="Loading policy" />;
  }

  const renderInputOrNullmessage = () => {
    if (
      getPolicyQuery &&
      getPolicyQuery.data &&
      getPolicyQuery.data.policyItems &&
      getPolicyQuery.data.policyItems.length > 0
    ) {
      return (
        getPolicyQuery &&
        getPolicyQuery.data &&
        getPolicyQuery.data.policyItems.map((policyInfo, index) => (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                required={true}
                value={policyInfo}
                checked={policyCheckItems.includes(policyInfo)}
                name={policyCheckItems}
                onChange={handlePolicyCheckBox}
              />
            }
            label={policyInfo}
          />
        ))
      );
    } else {
      return 'No policy found';
    }
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '10px',
        }}
      >
        <Typography variant="h6">
          Please fill all the policies that will apply to this claim!
        </Typography>
        <FormGroup>
          {renderInputOrNullmessage()}
          <WizardButtons
            {...props}
            nextHandler={handlePolicyCheckSubmit}
            disabled={policyCheckItems.length === 0}
            nextText="Submit"
          />
        </FormGroup>
      </div>
    </div>
  );
};
